import { environment } from '../../../environments/environment';
import { SessionClaims, decodeAccessTokenClaims } from './jwt.util';

const SESSION_KEY = `${environment.api_token}_session`;

export class TokenStorage {
  static getAccessToken(): string | null {
    return sessionStorage.getItem(environment.api_token);
  }

  static getRefreshToken(): string | null {
    return sessionStorage.getItem(environment.api_refresh_token);
  }

  static getExpiresAt(): string | null {
    return sessionStorage.getItem(`${environment.api_token}_expires`);
  }

  static setTokens(accessToken: string, refreshToken: string, expiresAt: string): void {
    sessionStorage.setItem(environment.api_token, accessToken);
    sessionStorage.setItem(environment.api_refresh_token, refreshToken);
    sessionStorage.setItem(`${environment.api_token}_expires`, expiresAt);
    this.setSession(decodeAccessTokenClaims(accessToken));
  }

  static setSession(claims: SessionClaims): void {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(claims));
  }

  static getSession(): SessionClaims {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) {
      const token = this.getAccessToken();
      return token ? decodeAccessTokenClaims(token) : { userId: null, tenantGuid: null, email: null, role: null };
    }

    try {
      return JSON.parse(raw) as SessionClaims;
    } catch {
      return { userId: null, tenantGuid: null, email: null, role: null };
    }
  }

  static getTenantGuid(): string | null {
    return this.getSession().tenantGuid;
  }

  static clear(): void {
    sessionStorage.removeItem(environment.api_token);
    sessionStorage.removeItem(environment.api_refresh_token);
    sessionStorage.removeItem(`${environment.api_token}_expires`);
    sessionStorage.removeItem(SESSION_KEY);
  }

  static isAuthenticated(): boolean {
    const token = this.getAccessToken();
    const expires = this.getExpiresAt();
    if (!token || !expires) return false;
    return new Date(expires).getTime() > Date.now();
  }
}
